import Vue from 'vue'
import Router from 'vue-router'
// modules
import auth from '@/modules/auth'
import admin from '@/modules/admin'
import profile from '@/modules/profile'
import objects from '@/modules/objects'
import dashboard from '@/modules/dashboard'
import client from '@/modules/client'
import manager from '@/modules/manager'
import schedule from '@/modules/schedule'
import partners from '@/modules/partners'
import partner from '@/modules/partner'
import content from '@/modules/content'
import dictionaries from '@/modules/dictionaries'
import shop from '@/modules/shop'
import seo from '@/modules/seo'
import development from '@/modules/development'
import blocks from '@/modules/blocks'
import objectmanager from '@/modules/objectmanager'
import job from '@/modules/job'
import checklist from '@/modules/checklist'
// eof modules
import Security from '@/security'
import { userRoles } from '@/enums/user-roles'

let router = new Router({
  mode: 'history',

  scrollBehavior(to, from, position) {
    return new Promise(resolve => {
      if (position) {
        setTimeout(() => resolve(position))
      } else {
        setTimeout(() => resolve({ x: 0, y: 0 }))
      }
    })
  },

  routes: [
    {
      name: 'Index',
      path: '/',
      component: () => import('@/components/layouts/Common'),
      redirect: { name: 'Dashboard.Index' },
      children: dashboard,
      meta: {
        roles: [
          userRoles.Admin,
          userRoles.User,
          userRoles.Client,
          userRoles.Manager
        ]
      }
    },
    {
      name: 'Auth',
      path: '/auth',
      component: () => import('@/components/layouts/Auth'),
      redirect: { name: 'Auth.Login' },
      children: auth
    },
    {
      name: 'Admin',
      path: '/admin',
      component: () => import('@/components/layouts/Common'),
      children: admin,
      meta: { roles: [userRoles.Admin] }
    },
    {
      name: 'Profile',
      path: '/profile',
      component: () => import('@/components/layouts/Common'),
      children: profile,
      meta: {
        roles: [
          userRoles.Admin,
          userRoles.Client,
          userRoles.User,
          userRoles.Editor,
          userRoles.Manager,
          userRoles.Boss
        ]
      }
    },
    {
      name: 'Manager',
      path: '/manager',
      component: () => import('@/components/layouts/Common'),
      children: manager,
      meta: { roles: [userRoles.Admin, userRoles.Manager] }
    },
    {
      name: 'Schedule',
      path: '/schedule',
      component: () => import('@/components/layouts/Common'),
      children: schedule,
      meta: { roles: [userRoles.Admin, userRoles.ScheduleManager] }
    },
    {
      name: 'ObjectManager',
      path: '/objectmanager',
      component: () => import('@/components/layouts/Common'),
      children: objectmanager,
      meta: { roles: [userRoles.Admin, userRoles.ObjectManager] }
    },
    {
      name: 'Job',
      path: '/job',
      component: () => import('@/components/layouts/Common'),
      children: job,
      meta: {
        roles: [userRoles.Admin, userRoles.JobManager]
      }
    },
    {
      name: 'Checklist',
      path: '/checklist',
      component: () => import('@/components/layouts/Common'),
      children: checklist,
      meta: {
        roles: [userRoles.ChecklistManager]
      }
    },
    {
      name: 'Objects',
      path: '/objects',
      component: () => import('@/components/layouts/Common'),
      redirect: { name: 'Objects.Complexes' },
      children: objects,
      meta: { roles: [userRoles.Admin, userRoles.Editor] }
    },
    {
      name: 'Client',
      path: '/client',
      component: () => import('@/components/layouts/Common'),
      redirect: { name: 'Client.Deals' },
      children: client,
      meta: {
        roles: [userRoles.Admin, userRoles.Client]
      }
    },
    {
      name: 'Partner',
      path: '/partner',
      component: () => import('@/components/layouts/Common'),
      redirect: { name: 'Partner.Agreement' },
      children: partner,
      meta: {
        roles: [userRoles.Admin, userRoles.LoyaltyPartner]
      }
    },
    {
      name: 'Partners',
      path: '/partners',
      component: () => import('@/components/layouts/Common'),
      redirect: { name: 'Partners.Organizations' },
      children: partners,
      meta: {
        roles: [userRoles.Admin, userRoles.ManagerPartner]
      }
    },
    {
      name: 'Content',
      path: '/content',
      component: () => import('@/components/layouts/Common'),
      children: content,
      meta: {
        roles: [
          userRoles.Admin,
          userRoles.ContentManager,
          userRoles.ContentPromo
        ]
      }
    },
    {
      name: 'Dictionaries',
      path: '/dictionaries',
      component: () => import('@/components/layouts/Common'),
      redirect: { name: 'Dictionaries.Infrastructure.List' },
      children: dictionaries,
      meta: {
        roles: [userRoles.Admin, userRoles.ContentManager]
      }
    },
    {
      name: 'Shop',
      path: '/shop',
      component: () => import('@/components/layouts/Common'),
      children: shop,
      meta: {
        roles: [userRoles.Admin, userRoles.ShopManager, userRoles.ShopSale]
      }
    },
    {
      name: 'Seo',
      path: '/seo',
      component: () => import('@/components/layouts/Common'),
      children: seo,
      meta: {
        roles: [userRoles.SeoManager]
      }
    },
    {
      name: 'Development',
      path: '/development',
      component: () => import('@/components/layouts/Common'),
      children: development,
      meta: {
        roles: [userRoles.SiteDevelopment]
      }
    },
    {
      name: 'Blocks',
      path: '/blocks',
      component: () => import('@/components/layouts/Common'),
      redirect: { name: 'Blocks.List' },
      children: blocks,
      meta: {
        roles: [userRoles.Admin]
      }
    },
    {
      name: '403',
      path: '/403',
      component: () => import('@/components/403')
    },
    {
      name: '404',
      path: '/404',
      component: () => import('@/components/404')
    },
    {
      path: '*',
      redirect: '404'
    }
  ]
})

Vue.use(Router)
Vue.use(Security, { router })

export default router
